import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { getAllRetailers } from "../../../services/retailer.service";
import { useSelector } from "react-redux";
import { addWallet } from "../../../services/wallet.service";

export default function WalletAdd() {
  const [isLoading2, setIsLoading2] = useState(false);
  const [retailers, setRetailers] = useState([]);
  const { token } = useSelector((state) => state?.auth);
  const [retailer, setRetailer] = useState(null);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    watch,
  } = useForm();

  const fetchRetailers = async (page = false) => {
    try {
      const params = { page };
      const res = await getAllRetailers(token, params);
      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);

        setRetailers(res?.data || []);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch Retailer. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching Retailer:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchRetailers();
  }, []);

  const retailerOptions = [
    ...retailers.map((retailer) => ({
      value: retailer.retailer_id,
      label: retailer.retailer_name,
      added_by: retailer?.added_by,
    })),
    { value: "addRetailer", label: "Add Retailer", isAddOption: true },
  ];

  const handleRetailerChange = async (selectedOption) => {
    clearErrors("retailer");
    setRetailer(selectedOption);
    setValue("retailer", selectedOption);

    if (selectedOption?.value === "addRetailer") {
      navigate("/retailer/add");
    }
  };

  const customStyles = {
    option: (provided, state) => {
      if (state.data.isAddOption) {
        return {
          ...provided,
          backgroundColor: "#4baebc",
          fontWeight: "bold",
          color: "white",
          cursor: "pointer",
        };
      }
      return provided;
    },
  };

  const customFilterOption = (candidate, input) => {
    if (candidate.data.isAddOption) {
      return true;
    }
    return candidate?.label?.toLowerCase().includes(input.toLowerCase());
  };

  const onSubmit = async (item) => {
    console.log(item);

    setIsLoading2(true);

    const data = {
      retailer_id: item.retailer?.value,
      credit_wallet: parseFloat(item.amount),
      note: item.note,
    };

    // console.log(data);

    try {
      const res = await addWallet(token, data);
      // console.log(res.data);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Success!",
          text: `₹${(item.amount * 1)?.toLocaleString(
            "en-IN",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}/- added to ${retailer?.label}'s wallet successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/retailer/credit-wallet");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.details?.transaction_id[0] ||
            "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during wallet transaction:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Credit Wallet</h4>
                <Link to="/retailer/credit-wallet">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row mb-5">
                      {/* Retailer Dropdown */}
                      <div className="mb-5 col-sm-4">
                        <div className="d-flex">
                          <label className="form-label">Retailer Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <Select
                          options={retailerOptions}
                          {...register("retailer", {
                            required: "Retailer is required",
                          })}
                          onChange={handleRetailerChange}
                          placeholder="Select & Search Retailer"
                          isClearable
                          styles={customStyles}
                          filterOption={customFilterOption}
                        />
                        {errors.retailer && (
                          <p className="error">{errors.retailer.message}</p>
                        )}
                      </div>

                      <div className="mb-5 col-md-4">
                        <div className="d-flex">
                          <label className="form-label">Credit Amount</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter amount"
                          {...register("amount", {
                            required: "Credit amount is required",
                            min: {
                              value: 1,
                              message: "Amount must be greater than zero",
                            },
                          })}
                        />
                        {errors.amount && (
                          <p className="error">{errors.amount.message}</p>
                        )}
                      </div>

                      <div className="mb-5 col-md-4">
                        <label className="form-label">Note</label>
                        <textarea
                          type="number"
                          className="form-control"
                          placeholder="Enter Note"
                          {...register("note")}
                        />
                      </div>

                      <div className="my-5"></div>
                      <div className="my-5"></div>
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4 mt-5">
                        <button type="submit" className="btn btn-primary w-100">
                          SUBMIT TRANSACTION
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4 mt-5">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          PROCESSING...
                        </button>
                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
